import * as Sentry from "@sentry/react-native";

import { AHText, ScaleFactorProvider } from "arkh";
import React, { PropsWithChildren } from "react";
import { View, useWindowDimensions } from "react-native";

import { ErrorBoundary } from "react-error-boundary";
import { FontLoader } from "../common/FontLoader";
import { Main } from "./Main";
import { UnitSizeProvider } from "./UnitSizeProvider";

import { IntlProvider } from "react-intl";
import { useGuessLocale } from "./useGuessLocale";
import { getLocaleMessages } from "./getLocaleMessages";

Sentry.init({
  dsn: "https://27d34cfb7d358f392c1ed2d350461eb3@o4507135394185216.ingest.de.sentry.io/4508756162052176",
  sendDefaultPii: true,
});

const BackgroundWrapper = (props: PropsWithChildren<object>) => {
  return (
    <View
      style={{
        backgroundColor: "#F2F2F2",
        flex: 1,
        height: "100%",
      }}
    >
      {props.children}
    </View>
  );
};

function App() {
  const { height, width, scale } = useWindowDimensions();

  const numColumns = 8;
  const unitSize =
    Math.min(width / numColumns, (height * scale - 100) / 4 - 2) - 4;

  const guessLocale = useGuessLocale();
  return (
    <IntlProvider
      defaultLocale="en"
      locale={guessLocale}
      messages={getLocaleMessages(guessLocale)}
    >
      <ScaleFactorProvider value={unitSize / 236}>
        <UnitSizeProvider value={unitSize}>
          <BackgroundWrapper>
            <ErrorBoundary
              onError={(err) => {
                Sentry.captureException(err);
                setTimeout(() => {
                  location.reload();
                }, 8000);
              }}
              fallbackRender={(err) => {
                return (
                  <View>
                    <AHText type="body-big">Error {err.error?.name}</AHText>
                  </View>
                );
              }}
            >
              <View
                style={{
                  width: "100%",
                  height: "100%",
                  flex: 1,
                }}
              >
                <FontLoader>
                  <Main guessLocale={guessLocale} />
                </FontLoader>
              </View>
            </ErrorBoundary>
          </BackgroundWrapper>
        </UnitSizeProvider>
      </ScaleFactorProvider>
    </IntlProvider>
  );
}

export default App;
